import type { User } from '../api/types';
import { userSkippedEmailVerification } from '../auth/UniversalSignup/useSignupStep';

/**
 * True when the user must continue onboarding on /signup (same rules as OnboardingGate).
 * Patients: medical + dosha (levels 4–5). Healthcare providers: basic profile only (level 3).
 */
export function needsSignupResume(user: User | null | undefined): boolean {
  if (!user || user.role === 'admin') return false;

  const level = user.profile_completion_level ?? 0;
  const emailVerified =
    user.verification_email === true ||
    (user.verification_email as unknown) === 1 ||
    (user.verification_email as unknown) === 'true';

  const skipped = userSkippedEmailVerification(user);
  const isGoogleUser =
    user.auth_provider === 'google' || Boolean(user.google_id);
  const isPatient = user.role !== 'doctor' && user.role !== 'admin';

  if (user.role === 'doctor') {
    if (!emailVerified) return true;
    if (level < 3) return true;
    return false;
  }

  if (level < 5) return true;

  if (skipped && !emailVerified) return true;

  if (isGoogleUser && isPatient && user.phone_verified !== true) return true;

  return false;
}
